const BAR_MAX_HEIGHT = 100;
const VALUE_LABEL_SPACE = 18;

const ARROW_CLASSES = 'text-gray-700 w-4 h-4 inline';

export { BAR_MAX_HEIGHT, VALUE_LABEL_SPACE, ARROW_CLASSES };
